<template>
  <page-layout
    v-loading="loading"
    :title="courseTitle"
    titleToolTipShow
    :icon-config="{
      isBack: true,
      isImg: false,
      backText: '返回课题'
    }"
    helpMode="research"
  >
    <div slot="custom-title" class="course-title-content">
      <el-tooltip effect="dark" placement="bottom">
        <div slot="content" :style="{ maxWidth: '300px' }">{{ courseTitle }}</div>
        <div class="title-text single-ellipsis">统计图表：{{ courseTitle }}</div>
      </el-tooltip>
      <i class="iconfont iconbianji course-edit-icon" @click="editorChartApis.updTitle(courseTitle)"></i>
    </div>

    <course-invite slot="custom-btn" v-if="courseDetail" :courseDetail="courseDetail" />

    <!-- <div slot="custom-btn" v-if="false && changeCondition && !handleDisabled">
      <div class="pending word-smaller" v-if="saveLoading">
        <span><i class="el-icon-loading"></i></span>
        <span :style="{ color: '#77839E' }">保存中...</span>
      </div>
      <div class="done word-smaller" v-else>
        <span><i class="el-icon-check"></i></span>
        <span :style="{ margin: '0 6px 0 0' }">{{ updateTime | dateFilter('HH:mm:ss') }}</span>
        <span :style="{ color: '#77839E' }">保存成功!</span>
      </div>
    </div> -->

    <template v-if="courseDetail">
      <editor-chart
        :chart-index-id="chartIndexId"
        :researchModel="currentResearch"
        :courseDetail="courseDetail"
        :handleDisabled="handleDisabled"
        @copy="copyModalShow = true"
        @initApis="apis => (editorChartApis = apis)"
        @changeChartDetail="changeChartDetail"
        @refreshCourseDetail="detail => refreshCourseSource(detail._source)"
      >
        <researchOriginData
          slot="originData"
          :course-detail="courseDetail"
          :chart-index-id="chartIndexId"
          :researchModel="currentResearch"
          :handleDisabled="handleDisabled"
          @initApis="apis => (originDataApis = apis)"
          @changeOriginData="changeOriginDataHandle"
          @changeChartDetail="changeChartDetail"
          @refreshCourseDetail="detail => refreshCourseSource(detail._source)"
        />
      </editor-chart>
    </template>

    <copyModal
      v-if="copyModalShow"
      :show.sync="copyModalShow"
      :courseDetail="courseDetail"
      :researchModel="currentResearch"
      @success="refreshCourseSource"
    />
  </page-layout>
</template>

<script>
import editorChart from './components/editorChart';
import researchOriginData from './components/researchOriginData';
import courseInvite from '@/components/courseInvite/index';
import copyModal from './components/copyModal';
import { services } from '@/service';
import dayjs from 'dayjs';
import { leavePage } from '@/lib/utils';
import { cloneDeep, uniqueId } from 'lodash';
import { computed } from 'vue';

export default {
  components: { editorChart, researchOriginData, courseInvite, copyModal },
  data() {
    return {
      loading: true,
      courseDetail: null,
      chartIndexId: -1,
      editorChartApis: null,
      originDataApis: null,
      charts: [],
      saveLoading: false,
      isCancel: false,
      changeCondition: false,
      updateTime: '',
      copyModalShow: false,
      courseUnitGroups: []
    };
  },
  provide() {
    return {
      courseUnitGroups: computed(() => this.courseUnitGroups)
    };
  },
  computed: {
    handleDisabled() {
      if (!this.courseDetail) {
        return true;
      }
      if (this.courseDetail._source.type === '示例课题' && !this.$store.getters.isAdmin) {
        return true;
      }
      if (this.courseDetail._source.limit === 'read') {
        return true;
      }
      return false;
    },
    courseTitle() {
      if (!this.currentResearch) {
        return '';
      }
      return this.currentResearch.title || '';
    },
    currentResearch() {
      return this.charts.find(chartItem => chartItem.index_id === this.chartIndexId);
    }
  },
  destroyed() {
    // window.removeEventListener('beforeunload', this.beforeunloadFn);
  },
  created() {
    this.beforeunloadFn = e => {
      if (!this.currentResearch) {
        return true;
      }
      const oldResearch = this.courseDetail._source.chart.find(chartItem => chartItem.index_id === this.chartIndexId);
      let isChange = false;
      if (this.currentResearch.conditionTemp !== oldResearch.conditionTemp) {
        isChange = true;
      }
      if (JSON.stringify(this.currentResearch.sortInfo || {}) !== JSON.stringify(oldResearch.sortInfo || {})) {
        isChange = true;
      }
      if (JSON.stringify(this.currentResearch.rows) !== JSON.stringify(oldResearch.rows)) {
        isChange = true;
      }
      if (JSON.stringify(this.currentResearch.columns) !== JSON.stringify(oldResearch.columns)) {
        isChange = true;
      }
      if (JSON.stringify(this.currentResearch.statistics) !== JSON.stringify(oldResearch.statistics)) {
        isChange = true;
      }
      if (isChange) {
        return leavePage(e);
      } else {
        return true;
      }
    };
    // window.addEventListener('beforeunload', this.beforeunloadFn);
  },
  async mounted() {
    try {
      const [courseDetail, courseUnitGroups] = await Promise.all([
        services.courseware.getCoursewareDetail(this.$route.query.courseware_id),
        services.courseware.getCourseUnitGroups(this.$route.query.courseware_id)
      ]);
      this.courseDetail = courseDetail;
      this.courseUnitGroups = courseUnitGroups;
      this.charts = cloneDeep(this.courseDetail._source.chart);
      this.chartIndexId = Number(this.$route.query.index_id || 0);
    } catch (err) {
      this.$error(err);
    } finally {
      this.loading = false;
    }
  },
  methods: {
    cancelHandle() {
      this.isCancel = true;
      this.$router.back();
    },
    // 废弃，change的params也过时
    checkHistoryHandle(item) {
      const index = this.charts.findIndex(chartItem => chartItem.index_id === this.chartIndexId);
      this.charts[index].conditionTemp = item.conditionTemp || '';
      this.editorChartApis.changeConditionInfo({
        rows: item.rows,
        columns: item.columns,
        statistics: item.statistics
      });
      this.originDataApis.init(item);
    },
    // editorChart组件和researchOriginData修改配置或者数据时需要更新editorChart内的图表
    async changeChartDetail({
      chartIndexId,
      detail,
      editField = false,
      refreshData = false,
      saveChart = true,
      saveCallback
    }) {
      this.changeCondition = true;
      const index = this.charts.findIndex(chartItem => chartItem.index_id === chartIndexId);
      this.charts.splice(index, 1, detail);
      if (saveChart) {
        await this.saveChartsHandle({ isRoute: false, isUpdFields: editField, saveCallback });
      }
      // 如果 saveChartsHandle 报错则不会运行下方，如果需要继续执行则需要try
      if (refreshData) {
        this.editorChartApis.setCondition();
      }
    },
    changeOriginDataHandle(params) {
      this.changeChartDetail(params);
      this.$nextTick(() => {
        this.editorChartApis.setCondition();
      });
    },
    refreshCourseSource(courseSource) {
      this.courseDetail._source = courseSource;
      this.charts = cloneDeep(this.courseDetail._source.chart);
    },
    async saveChartsHandle(params) {
      const { isRoute = false, isUpdFields = false, saveCallback } = params;
      try {
        this.saveLoading = true;
        const historyList = JSON.parse(this.currentResearch.historyList || '[]').slice(0, 29);
        historyList.unshift({
          dateTime: `${dayjs().unix()}_${uniqueId()}`
        });
        const historyListStr = JSON.stringify(historyList);
        const index = this.charts.findIndex(chartItem => chartItem.index_id === this.chartIndexId);
        this.charts.splice(index, 1, {
          ...this.currentResearch,
          historyList: historyListStr
        });
        const newCourseDetail = {
          ...this.courseDetail._source,
          chart: this.charts
        };
        await services.courseware.saveCourseware(this.$route.query.courseware_id, newCourseDetail, { isUpdFields });
        // this.$message.success('研究点保存成功');
        this.updateTime = Date.now();
        this.courseDetail._source = newCourseDetail;
        if (isRoute) {
          this.$router.back();
        }
      } catch (err) {
        this.$error(err);
        throw Error(err);
      } finally {
        this.saveLoading = false;
        saveCallback && saveCallback();
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.course-title-content {
  display: flex;
  align-items: center;

  .course-edit-icon {
    margin-left: 2px;
    padding: 2px 3px;
    cursor: pointer;
    opacity: 0;
  }

  .title-text {
    display: inline-block;
    max-width: calc(100% - 30px);
  }

  &:hover {
    .course-edit-icon {
      opacity: 1;
    }
  }
}
.iconlishijilu {
  position: relative;
  top: 2px;
  font-size: 18px;
  margin-left: 2px;
}
.done {
  color: #67c23a;
  margin-right: 10px;
  i {
    margin-right: 5px;
  }
}

.pending {
  color: #409eff;
  margin-right: 10px;
  i {
    margin-right: 5px;
  }
}
.vip-tip {
  .icon-big {
    margin-right: 5px;
  }
  .upgrade {
    display: inline-block;
    width: 72px;
    line-height: 24px;
    background: linear-gradient(270deg, #ff923b 0%, #fdd16c 100%);
    border-radius: 12px;
    margin-left: 10px;
    text-align: center;
    color: #a14a0e;
    cursor: pointer;
  }
}
</style>
